var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWchecker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-1 {opacity: 0.15;}.cls-2 {fill: none;}.cls-3,.cls-7 {fill: #f8f8f8;}.cls-4 {opacity: 0.10;}.cls-5,.cls-6 {opacity: 0.05;}.cls-8 {fill: #302d2b;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 150,
    width: 150,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M 90.000803,23.096995 A 66.903005,66.903005 0 1 0 156.9038,90 66.970187,66.970187 0 0 0 90.000803,23.096995 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M 90.000803,40.139067 A 49.860933,49.860933 0 1 0 139.87293,90 49.91692,49.91692 0 0 0 90.000803,40.139067 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m 59.096653,125.67414 -4.165342,-0.39191 0.391901,-4.16534 -4.075765,-0.88457 0.906969,-4.08696 -3.9302,-1.41084 1.466827,-3.96379 -3.728653,-1.90352 1.903516,-3.71746 -3.459922,-2.3514 2.351403,-3.459922 -3.135203,-2.765698 2.709712,-3.1464 -2.765699,-3.135204 3.135204,-2.765698 -2.351401,-3.459921 3.459921,-2.351403 -1.903517,-3.728652 3.784639,-1.892319 -1.410843,-3.9414 3.874216,-1.410841 -0.906969,-4.086962 4.042174,-0.906969 -0.391902,-4.165342 4.165342,-0.3919 0.134367,-4.187737 4.176539,0.134367 0.683027,-4.086962 4.13175,0.660632 1.119715,-4.019779 4.008582,1.119716 1.668376,-3.840625 3.829427,1.668377 2.228234,-3.605485 3.594287,2.12746 2.564149,-3.359147 3.359146,2.564149 2.95605,-2.95605 2.967245,2.95605 3.359148,-2.564149 2.564157,3.359147 3.59428,-2.12746 2.12745,3.605485 3.84063,-1.668377 1.54521,3.840625 4.00858,-1.119716 1.11972,4.019779 4.12055,-0.660632 0.66064,4.13175 3.8966,-0.123164 A 49.838539,49.838539 0 1 0 59.208624,129.19004 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M 90.99735,67.706462 A 23.30128,23.30128 0 1 1 67.707265,91.007744 23.323674,23.323674 0 0 1 90.99735,67.706462 m 0,-1.858727 a 25.160009,25.160009 0 1 0 25.1712,25.160009 25.1936,25.1936 0 0 0 -25.1712,-25.160009 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M 90.000803,66.754704 A 23.30128,23.30128 0 1 1 66.755507,90 23.323674,23.323674 0 0 1 90.000803,66.754704 m 0,-1.858727 A 25.160009,25.160009 0 1 0 115.2056,90 25.182404,25.182404 0 0 0 90.000803,64.895977 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M 90.974954,54.269876 A 36.715473,36.715473 0 1 1 54.270678,90.98535 36.760262,36.760262 0 0 1 90.974954,54.269876 m 0,-1.858728 A 38.574202,38.574202 0 1 0 129.56036,90.98535 38.618989,38.618989 0 0 0 90.974954,52.411148 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M 90.000803,53.340512 A 36.715473,36.715473 0 1 1 53.330118,90 36.760262,36.760262 0 0 1 90.000803,53.340512 m 0,-1.869924 A 38.585398,38.585398 0 1 0 128.63099,90 38.618989,38.618989 0 0 0 90.000803,51.470588 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m 91.053335,82.161991 a 8.85695,8.85695 0 1 1 -8.890542,8.890541 8.8681472,8.8681472 0 0 1 8.890542,-8.890541 m 0,-1.869925 A 10.726875,10.726875 0 1 0 101.78021,91.018941 10.738072,10.738072 0 0 0 91.053335,80.292066 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M 90.000803,81.14305 A 8.85695,8.85695 0 1 1 81.143853,90 a 8.8681472,8.8681472 0 0 1 8.85695,-8.85695 m 0,-1.869925 A 10.726875,10.726875 0 1 0 100.72768,90 10.738072,10.738072 0 0 0 90.000803,79.273125 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M 90.000803,24.015162 A 65.984838,65.984838 0 1 1 24.004767,90 66.063218,66.063218 0 0 1 90.000803,24.015162 m 0,-3.728653 A 69.713491,69.713491 0 1 0 159.7255,90 69.791871,69.791871 0 0 0 90.000803,20.286509 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWchecker);
export default __webpack_public_path__ + "static/media/wchecker.16e38d30453d0242b634c9b86b5faaf0.svg";
export { ForwardRef as ReactComponent };